import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Pressable from '@atlaskit/primitives/pressable';
import React, { useLayoutEffect, useRef } from 'react';
import { Container, Img } from './styles';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
const getAspectRatio = (aspectRatio, width, height) => {
  if (aspectRatio) {
    return aspectRatio;
  }
  const validPixelWidth = width && Number.isInteger(parseInt(width, 10));
  const validPixelHeight = height && Number.isInteger(parseInt(height, 10));
  if (validPixelHeight && validPixelWidth) {
    return "".concat(width, "/").concat(height);
  }
  return 'auto';
};
export const Image = props => {
  const {
    src,
    alt,
    width = 'auto',
    height = 'auto',
    aspectRatio,
    onImageInteraction,
    borderRadius = '8px'
  } = props;
  const interactive = typeof onImageInteraction === 'function';
  const imageRef = useRef(null);
  const containerRef = useRef(null);
  const altText = alt ? {
    alt
  } : {
    'aria-hidden': true
  };
  const imgProps = _objectSpread({
    src,
    width,
    height,
    'data-testid': props['data-testid']
  }, altText);

  // We use direct DOM manipulation to bypass react's
  // re-rendering, that can cause a delay in image load
  useLayoutEffect(() => {
    // Prepare the image for fading-in. We do this in
    // `useLayoutEffect` which is executed only on the client side.
    // This means images are still visible if JS does not load for
    // some reason after a server side render
    if (imageRef.current && !imageRef.current.complete) {
      imageRef.current.style.opacity = '0';
    }
  }, []);
  const handleLoad = () => {
    if (imageRef.current) {
      imageRef.current.style.opacity = '1';
    }
    if (containerRef.current) {
      containerRef.current.style.backgroundColor = 'transparent';
    }
  };
  const content = /*#__PURE__*/_jsx(Container, {
    $aspectRatio: getAspectRatio(aspectRatio, width, height),
    $borderRadius: borderRadius,
    ref: containerRef,
    "data-testid": props['data-testid'] ? "".concat(props['data-testid'], "-container") : null,
    children: /*#__PURE__*/_jsx(Img, _objectSpread({
      ref: imageRef,
      onLoad: handleLoad
    }, imgProps))
  });
  if (interactive) {
    return /*#__PURE__*/_jsx(Pressable, {
      onClick: onImageInteraction,
      padding: "space.0",
      backgroundColor: "color.background.neutral.subtle",
      children: content
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: content
  });
};